import { Box, Grid } from '@mui/material';
import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Media, UploadState, UploadType } from '@synergy/models';
import { PoolFileList, PoolTextArea, PoolTypography } from '@synergy/components';

import { DemandAccount } from '../../../../../models/demand-account';
import { useAppSelector } from '../../../../../../../store/use-appstate-selector';

export const FeedbackCustomerNotes = () => {
    const mediaBaseUrl = useAppSelector(state => state.settings.mediaBaseUrl);

    return (
        <Box sx={{ mr: 3, mb: 4 }}>
            <PoolTypography styleType="sectionTitle" id="app.demands.detail.feedback.noteFromCustomer" />
            <Grid container={true} spacing={3} direction="column" alignItems="flex-end">
                <Grid item={true} container={true} xs={12} direction="row">
                    <Grid item={true} xs={7} sx={{ pr: 1 }}>
                        <Field name="noteFromCustomer">
                            {({ field }: FieldProps<string>) => (
                                <PoolTextArea
                                    label={<FormattedMessage id="app.label.note" />}
                                    rows="5"
                                    rowsMax="50"
                                    {...field}
                                    readOnly={true}
                                />
                            )}
                        </Field>
                    </Grid>
                    <Grid item={true} xs={5} sx={{ pr: 1 }}>
                        <Field>
                            {({ form }: FieldProps<DemandAccount>) => (
                                <PoolFileList
                                    acceptedFiles={(form.values.media as Media[])
                                        .filter(file => file.type === UploadType.Customer)
                                        .map(media => {
                                            if (!media.state) {
                                                return {
                                                    ...media,
                                                    state: UploadState.Finished,
                                                };
                                            }

                                            return media;
                                        })}
                                    downloadBaseUrl={mediaBaseUrl}
                                    readOnly={true}
                                />
                            )}
                        </Field>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};
